import type { ColorValue } from 'react-native'
import React from 'react'
import Svg, { Path } from 'react-native-svg'

export type BottomNavIconName =
  'dashboard' | 'library' | 'statistics' | 'settings'

interface BottomNavIconProps {
  name: BottomNavIconName
  size?: number
  color: ColorValue
}

function DashboardIcon({
  size,
  color,
}: Pick<BottomNavIconProps, 'size' | 'color'>) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        d="M3 12L5 10M5 10L12 3L19 10M5 10V20C5 20.2652 5.10536 20.5196 5.29289 20.7071C5.48043 20.8946 5.73478 21 6 21H9M19 10L21 12M19 10V20C19 20.2652 18.8946 20.5196 18.7071 20.7071C18.5196 20.8946 18.2652 21 18 21H15M9 21C9.26522 21 9.51957 20.8946 9.70711 20.7071C9.89464 20.5196 10 20.2652 10 20V16C10 15.7348 10.1054 15.4804 10.2929 15.2929C10.4804 15.1054 10.7348 15 11 15H13C13.2652 15 13.5196 15.1054 13.7071 15.2929C13.8946 15.4804 14 15.7348 14 16V20C14 20.2652 14.1054 20.5196 14.2929 20.7071C14.4804 20.8946 14.7348 21 15 21M9 21H15"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}

// Library/book icon (book with lines)
function LibraryIcon({
  size,
  color,
}: Pick<BottomNavIconProps, 'size' | 'color'>) {
  return (
    <Svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <Path
        d="M6 12V15M10 12V15M14 12V15M1 19H19M1 8H19M1 5L10 1L19 5H1ZM2 8H18V19H2V8Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}

function SettingsIcon({
  size,
  color,
}: Pick<BottomNavIconProps, 'size' | 'color'>) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        d="M13.675 4.317C13.249 2.561 10.751 2.561 10.325 4.317C10.049 5.452 8.749 5.99 7.753 5.382C6.209 4.442 4.443 6.209 5.383 7.752C5.5243 7.98375 5.60889 8.24559 5.62987 8.51621C5.65085 8.78683 5.60764 9.05859 5.50375 9.30935C5.39985 9.56011 5.23822 9.7828 5.032 9.95929C4.82578 10.1358 4.5808 10.2611 4.317 10.325C2.561 10.751 2.561 13.249 4.317 13.675C4.58056 13.7391 4.82529 13.8645 5.03127 14.0409C5.23726 14.2174 5.3987 14.44 5.50247 14.6906C5.60624 14.9412 5.64942 15.2128 5.62848 15.4832C5.60755 15.7537 5.5231 16.0153 5.382 16.247C4.442 17.791 6.209 19.557 7.752 18.617C7.98375 18.4757 8.24559 18.3911 8.51621 18.3701C8.78683 18.3491 9.05859 18.3924 9.30935 18.4963C9.56011 18.6001 9.7828 18.7618 9.95929 18.968C10.1358 19.1742 10.2611 19.4192 10.325 19.683C10.751 21.439 13.249 21.439 13.675 19.683C13.7391 19.4194 13.8645 19.1747 14.0409 18.9687C14.2174 18.7627 14.44 18.6013 14.6906 18.4975C14.9412 18.3938 15.2128 18.3506 15.4832 18.3715C15.7537 18.3924 16.0153 18.4769 16.247 18.618C17.791 19.558 19.557 17.791 18.617 16.248C18.4757 16.0162 18.3911 15.7544 18.3701 15.4838C18.3491 15.2132 18.3924 14.9414 18.4963 14.6907C18.6001 14.4399 18.7618 14.2172 18.968 14.0407C19.1742 13.8642 19.4192 13.7389 19.683 13.675C21.439 13.249 21.439 10.751 19.683 10.325C19.4194 10.2609 19.1747 10.1355 18.9687 9.95905C18.7627 9.78258 18.6013 9.55999 18.4975 9.30938C18.3938 9.05877 18.3506 8.78721 18.3715 8.51677C18.3924 8.24634 18.4769 7.98466 18.618 7.753C19.558 6.209 17.791 4.443 16.248 5.383C16.0162 5.5243 15.7544 5.60889 15.4838 5.62987C15.2132 5.65085 14.9414 5.60764 14.6907 5.50375C14.4399 5.39985 14.2172 5.23822 14.0407 5.032C13.8642 4.82578 13.7389 4.5808 13.675 4.317Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}

function StatisticsIcon({
  size,
  color,
}: Pick<BottomNavIconProps, 'size' | 'color'>) {
  const iconSize = size ?? 24

  return (
    <Svg
      width={iconSize}
      height={(iconSize * 18) / 20}
      viewBox="0 0 20 18"
      fill="none"
    >
      <Path
        d="M1 18C0.716667 18 0.479167 17.9042 0.2875 17.7125C0.0958333 17.5208 0 17.2833 0 17C0 16.7167 0.0958333 16.4792 0.2875 16.2875C0.479167 16.0958 0.716667 16 1 16H19C19.2833 16 19.5208 16.0958 19.7125 16.2875C19.9042 16.4792 20 16.7167 20 17C20 17.2833 19.9042 17.5208 19.7125 17.7125C19.5208 17.9042 19.2833 18 19 18H1ZM2.5 15C2.08333 15 1.72917 14.8542 1.4375 14.5625C1.14583 14.2708 1 13.9167 1 13.5V9.5C1 9.08333 1.14583 8.72917 1.4375 8.4375C1.72917 8.14583 2.08333 8 2.5 8C2.91667 8 3.27083 8.14583 3.5625 8.4375C3.85417 8.72917 4 9.08333 4 9.5V13.5C4 13.9167 3.85417 14.2708 3.5625 14.5625C3.27083 14.8542 2.91667 15 2.5 15ZM7.5 15C7.08333 15 6.72917 14.8542 6.4375 14.5625C6.14583 14.2708 6 13.9167 6 13.5V4.5C6 4.08333 6.14583 3.72917 6.4375 3.4375C6.72917 3.14583 7.08333 3 7.5 3C7.91667 3 8.27083 3.14583 8.5625 3.4375C8.85417 3.72917 9 4.08333 9 4.5V13.5C9 13.9167 8.85417 14.2708 8.5625 14.5625C8.27083 14.8542 7.91667 15 7.5 15ZM12.5 15C12.0833 15 11.7292 14.8542 11.4375 14.5625C11.1458 14.2708 11 13.9167 11 13.5V7.5C11 7.08333 11.1458 6.72917 11.4375 6.4375C11.7292 6.14583 12.0833 6 12.5 6C12.9167 6 13.2708 6.14583 13.5625 6.4375C13.8542 6.72917 14 7.08333 14 7.5V13.5C14 13.9167 13.8542 14.2708 13.5625 14.5625C13.2708 14.8542 12.9167 15 12.5 15ZM17.5 15C17.0833 15 16.7292 14.8542 16.4375 14.5625C16.1458 14.2708 16 13.9167 16 13.5V1.5C16 1.08333 16.1458 0.729167 16.4375 0.4375C16.7292 0.145833 17.0833 0 17.5 0C17.9167 0 18.2708 0.145833 18.5625 0.4375C18.8542 0.729167 19 1.08333 19 1.5V13.5C19 13.9167 18.8542 14.2708 18.5625 14.5625C18.2708 14.8542 17.9167 15 17.5 15Z"
        fill={color}
      />
    </Svg>
  )
}

export function BottomNavIcon({ name, size = 24, color }: BottomNavIconProps) {
  switch (name) {
    case 'dashboard':
      return <DashboardIcon size={size} color={color} />
    case 'library':
      return <LibraryIcon size={size} color={color} />
    case 'statistics':
      return <StatisticsIcon size={size} color={color} />
    case 'settings':
      return <SettingsIcon size={size} color={color} />
  }
}
